// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ViewUI from 'iview'
import 'iview/dist/styles/iview.css'
import './assets/font/SourceHanSansCN-Regular.css'

import uploader from 'vue-simple-uploader'
import store from './store/index.js'
import {setCookie,getCookie,delCookie} from './assets/cookie'
Vue.prototype.$cookieStore = {setCookie,getCookie,delCookie}

import axios from 'axios'
import qs from 'qs'
Vue.prototype.$axios = axios;      //解决在其他组件无法使用axios命令
Vue.prototype.$qs = qs;
import configUrl from '@/interface/index.js'
Vue.prototype.$configUrl = configUrl;
Vue.config.productionTip = false;
Vue.use(ViewUI)
Vue.use(axios)
Vue.use(uploader)
Vue.directive('title',{
  inserted: function (el, binding) {
    document.title = el.dataset.title
  }

})
/* eslint-disable no-new */
new Vue({

  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})





// WEBPACK FOOTER //
// ./src/main.js